import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function ModalFooter() {
	const [shouldSaveButtonBeDisabled, setShouldSaveButtonBeDisabled] =
		useState<boolean>(false);
	const [shouldDeleteButtonBeDisabled, setShouldDeleteButtonBeDisabled] =
		useState<boolean>(false);

	const { t } = useTranslation();
	const store = useContext(MyBetsStoreContext)?.cashoutStore;

	if (!store) {
		console.error("Expected store, got null");
		return null;
	}
	if (store.isAutosellModalCashedOut) {
		return (
			<button
				type="button"
				className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted"
				onClick={store.closeAutosellModal}
			>
				{t("COMMON.CLOSE")}
			</button>
		);
	} else if (store.isAutocashoutUnavailable) {
		return (
			<>
				{store.isConfigurationExists && (
					<button
						type="button"
						className="popup__btn popup__btn--destructive btn btn--med btn--primary--inverted u-color--sent--danger"
						disabled
					>
						{t("COMMON.DELETE")}
					</button>
				)}

				<button
					type="button"
					className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
					onClick={store.closeAutosellModal}
				>
					{t("COMMON.CLOSE")}
				</button>

				<button
					type="button"
					className="btn popup__btn popup__btn--primary btn btn--med btn--accent"
					onClick={async () => {
						if (store.openedAutosellModalBetSlipId) {
							await store.setSecureWinConfiguration(
								store.openedAutosellModalBetSlipId,
								Number(store.secureWinAmount)
							);
						}
					}}
					disabled={store.isSaveBtnDisabled}
				>
					{t("COMMON.SAVE")}
				</button>
			</>
		);
	} else {
		return (
			<>
				{store.isConfigurationExists && (
					<Button
						type="button"
						className="popup__btn popup__btn--destructive btn btn--med btn--primary--inverted u-color--sent--danger"
						onClick={async () => {
							setShouldDeleteButtonBeDisabled(true);
							if (store.openedAutosellModalBetSlipId) {
								await store.removeSecureWinConfiguration(
									store.openedAutosellModalBetSlipId
								);
							}
							setShouldDeleteButtonBeDisabled(false);
						}}
						disabled={shouldDeleteButtonBeDisabled}
						btnText={t("COMMON.DELETE")}
					></Button>
				)}

				<button
					type="button"
					className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
					onClick={store.closeAutosellModal}
				>
					{t("COMMON.CANCEL")}
				</button>

				<Button
					type="button"
					className="btn popup__btn popup__btn--primary btn btn--med btn--accent"
					onClick={async () => {
						setShouldSaveButtonBeDisabled(true);
						if (store.openedAutosellModalBetSlipId) {
							await store.setSecureWinConfiguration(
								store.openedAutosellModalBetSlipId,
								Number(store.secureWinAmount)
							);
						}
						setShouldSaveButtonBeDisabled(false);
					}}
					disabled={
						store.isSaveBtnDisabled || shouldSaveButtonBeDisabled
					}
					btnText={t("COMMON.SAVE")}
				></Button>
			</>
		);
	}
});
